import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import config from "config"

// ==================== ORGANIZACIONES ====================

async function fetchDependencias(params = {}) {
  const queryParams = new URLSearchParams()

  if (params.sucursalId) queryParams.append("sucursalId", params.sucursalId)
  if (params.nombre) queryParams.append("nombre", params.nombre)
  if (params.page !== undefined) queryParams.append("page", params.page)
  if (params.size !== undefined) queryParams.append("size", params.size)

  let url = `${config.api.baseURL}/dependencias-asistencia`
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`
  }

  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener las organizaciones")
      }
      return response.json()
    })
    .then((data) => {
      // El backend ahora retorna estructura paginada: {content: [...], totalElements, totalPages, ...}
      return data.content || []
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      return []
    })
}

async function fetchDependenciaById(id) {
  let url = `${config.api.baseURL}/dependencias-asistencia/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener la dependencia")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function createOrganizacion(data) {
  let url = `${config.api.baseURL}/dependencias-asistencia`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        return response.json().then((error) => {
          throw new Error(error.error || "Error al crear la dependencia")
        })
      }
      return response.json()
    })
    .then((result) => {
      showToast({ title: "Dependencia creada exitosamente", icon: "success" })
      return result
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function updateOrganizacion(id, data) {
  let url = `${config.api.baseURL}/dependencias-asistencia/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        return response.json().then((error) => {
          throw new Error(error.error || "Error al actualizar la dependencia")
        })
      }
      return response.json()
    })
    .then((result) => {
      showToast({ title: "Dependencia actualizada exitosamente", icon: "success" })
      return result
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      throw error
    })
}

async function deleteOrganizacion(id) {
  return Swal.fire({
    title: "¿Está seguro?",
    text: "Esta acción eliminará la dependencia permanentemente",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      let url = `${config.api.baseURL}/dependencias-asistencia/${id}`
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      return fetch(url, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (!response?.ok) {
            return response.json().then((error) => {
              throw new Error(error.error || "Error al eliminar la dependencia")
            })
          }
          showToast({ title: "Eliminado", text: "La dependencia ha sido eliminada", icon: "success" })
          return true
        })
        .catch((error) => {
          showToast({ icon: "error", title: "Error", text: error.message })
          throw error
        })
    }
    return false
  })
}

// ==================== SUCURSALES (para dropdown) ====================

async function fetchSucursales() {
  let url = `${config.api.baseURL}/sucursales`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener las sucursales")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({ icon: "error", title: "Error", text: error.message })
      return []
    })
}

export {
  fetchDependencias,
  fetchDependenciaById,
  createOrganizacion,
  updateOrganizacion,
  deleteOrganizacion,
  fetchSucursales,
}
